import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Badge } from './ui/Badge';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const timeline = [{
    days: '7 días',
    text: 'Verás los primeros brotes asomando por la superficie'
  }, {
    days: '15 días',
    text: 'Tu balcón habrá dejado de ser un espacio gris para ser una mancha verde visible desde la calle'
  }, {
    days: '30 días',
    text: 'Estarás cortando tu primera ración de rúcula orgánica'
  }];
  return <section ref={ref} className="w-full py-16 md:py-24 bg-gradient-to-b from-[#95D5B2] to-[#D8F3DC]" data-id="element-141">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-143">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-6" data-id="element-144">
            Tu Cronograma de Éxito
          </h2>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-145">
          {timeline.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-lg flex gap-4 items-start" data-id="element-146">
              <Badge className="bg-[#2D6A4F] text-white text-sm font-bold px-3 py-1 flex-shrink-0" data-id="element-147">
                {item.days}
              </Badge>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-148">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center" data-id="element-149">
          <p className="text-xl md:text-2xl text-[#2D6A4F] font-medium italic" data-id="element-150">
            No es magia, es biología aplicada al espacio urbano.
          </p>
        </motion.div>
      </div>
    </section>;
}